import React from "react";
import {Image, ImageProps} from "../raw-components/image/image";
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {AspectRatioContainerComponent} from '../raw-components/aspect-ratio-container/aspect-ratio-container.component';
import {HomepageHeaderArenaSkeletonBox} from './boxes/tiles/skeleton/home-page-header-arena-skeleton.box';
import { ByThemeRegistry } from "../../themes/architecture/by-theme-registry";
import {HeaderArenasStyle} from "../../themes/architecture/sections/theme-layout.interface";
import {HomePageHeaderArenaRatioImageWrapperBox} from "./boxes/tiles/ratio-image-wrapper/home-page-header-arena-ratio-image-wrapper.box";

interface HomePageHeaderArenaTileComponentState {
    isLoading: boolean;
}

export class HomePageHeaderArenaTileComponent extends OrbitComponentWithState<ImageProps, HomePageHeaderArenaTileComponentState> {
    private aspectRatioSizes: ByThemeRegistry<{width: number; height: number;}> = new ByThemeRegistry({width: 295, height: 275});

    constructor(props: ImageProps) {
        super(props);

        this.state = {
            isLoading: true
        };
        this.aspectRatioSizes.forCasino888({width: 219, height: 186});
        this.aspectRatioSizes.forWsop({width: 219, height: 186});
        this.aspectRatioSizes.forSI({width: 252, height: 150});
        this.aspectRatioSizes.forCasino777({width: 260, height: 244});
    }

    private _handleDoneLoading() {
        this.setState({ isLoading: false });
    }

    render() {
        return (
            <HomePageHeaderArenaRatioImageWrapperBox>
                <AspectRatioContainerComponent
                    {...this.aspectRatioSizes.getRegistryItem(this.services.theme.themeName)}
                >
                    <HomepageHeaderArenaSkeletonBox
                        isLoading={this.state.isLoading}
                        tilesSize={this.services.homepage.headerArenasStyleIsBigTiles ? HeaderArenasStyle.BigTiles : HeaderArenasStyle.SmallTiles}
                    />
                    {/* I have added width:100% and height:100% because lighthouse reports that images that has no width and height set and might affect the cls */}
                    {/* But I don't think it affects the layout of the page. */}
                    <Image {...this.props} onLoad={() => this._handleDoneLoading()} style={{...this.props.style, width: "100%", height: "100%"}}/>
                </AspectRatioContainerComponent>
            </HomePageHeaderArenaRatioImageWrapperBox>
        );
    }
}